import { render, staticRenderFns } from "./CoreStupidSeasonSelect.vue?vue&type=template&id=57b21284"
import script from "./CoreStupidSeasonSelect.vue?vue&type=script&lang=js"
export * from "./CoreStupidSeasonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports